import { WmOption, WmSelect } from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import { formatDate } from "../../common/helper";
import { ReportingYear, defaultReportingYear } from "../interfaces/Interface";

export interface ReportingYearsProps {
  reportingYears: ReportingYear[];
  selectedReportingYear: ReportingYear;
  selectReportingYear: (year: ReportingYear) => void;
}
const ReportingYears = ({
  reportingYears,
  selectedReportingYear,
  selectReportingYear
}: ReportingYearsProps) => {
  const academicYearLabel = useIntl().formatMessage({
    id: "app.reportingYears.academicYear"
  });

  return (
    <div className="reporting-year-width">
      <WmSelect
        label={academicYearLabel}
        labelPosition="left"
        id="select-terms"
      >
        {reportingYears.map((year: ReportingYear) => {
          return (
            <WmOption
              id={`reportingYears-${year.uuid}`}
              key={`reportingYears-${year.uuid}`}
              selected={selectedReportingYear?.uuid === year.uuid}
              onClick={() => selectReportingYear(year)}
            >
              {year.name}
            </WmOption>
          );
        })}
      </WmSelect>
      {selectedReportingYear && (
        <div className="reporting-year-duration">
          {`${formatDate(selectedReportingYear?.startDate)} - ${formatDate(
            selectedReportingYear?.endDate
          )}`}
        </div>
      )}
    </div>
  );
};

export const getDefaultReportingYear = (
  defaultReportingYear: ReportingYear,
  reportingYears: ReportingYear[]
) => {
  const currentReportingYear = reportingYears.find(
    (reportingYear) => reportingYear.isCurrent 
  );

  return currentReportingYear || reportingYears[0] || defaultReportingYear;
};

export const dateWithoutTimezone = (dateStr: string) => {
  if (dateStr) {
    const index = dateStr.indexOf("T");
    return index > 0 ? dateStr.slice(0, index) : dateStr;
  }
};
export default ReportingYears;
